import SkillTagList from './SkillTagList';

export default function AboutContent({ data }) {
  return (
    <div>
      {data.paragraphs.map((paragraph, index) => (
        <p key={index} className="text-gray-300 text-lg leading-relaxed mb-6 text-center sm:text-left">
          {paragraph}
        </p>
      ))}
      
      <SkillTagList skills={data.skillTags} />
    </div>
  );
}